import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Machine from 'layouts/machine';
import SignIn from 'layouts/authentication/sign-in';
import SignOut from 'layouts/authentication/sign-out';
import Boards from 'layouts/boards/';
import NoticeDetail from 'layouts/boards/boarddetail';
import Manual from 'layouts/manual';
import ManualDetail from 'layouts/manual/manualdetail';
import HelpDesk from 'layouts/helpdesk';
import QRCodeGenerator from 'layouts/qrcode';
import ReviewList from 'layouts/review';
import ReviewWrite from 'layouts/review/write';
import ReviewSuccess from 'layouts/review/success';
import ReviewManage from 'layouts/review/manage';
import PostingManagement from 'layouts/review/PostingManagement';
import PrivacyPolicy from 'layouts/privacy';
import OAuthCallback from 'components/OAuthCallback';
import PrivateRoute from './PrivateRoute'; // PrivateRoute 컴포넌트를 임포트합니다.
import Icon from '@mui/material/Icon';

// ESG 기능 관련 메뉴 키 목록
const ESG_MENU_KEYS = ['qrcode', 'reviews', 'review-manage', 'posting-manage'];

// PET 기능 관련 메뉴 키 목록 (메뉴얼, 공지사항, 기기관리)
const PET_MENU_KEYS = ['manual', 'manualdetail', 'boards', 'boarddetail', 'machine'];

/**
 * isESG 값에 따라 메뉴를 필터링하는 함수
 * @param {boolean} isESG - ESG 기능 활성화 여부
 * @returns {Array} 필터링된 routes 배열
 */
export const getFilteredRoutes = (isESG = false, isPET = false) => {
  let filteredRoutes = routes;
  
  // isESG가 false인 경우 ESG 관련 메뉴 숨김
  if (!isESG) {
    filteredRoutes = filteredRoutes.filter(route => !ESG_MENU_KEYS.includes(route.key));
  }
  
  // isPET이 false인 경우 PET 관련 메뉴 숨김 (메뉴얼, 공지사항, 기기관리)
  if (!isPET) {
    filteredRoutes = filteredRoutes.filter(route => !PET_MENU_KEYS.includes(route.key));
  }
  
  return filteredRoutes;
};

const routes = [
  {
    type: 'collapse',
    name: '매뉴얼',
    key: 'manual',
    icon: <Icon fontSize='small'>book</Icon>,
    route: '/manual',
    component: <PrivateRoute element={<Manual />} />,
  },
  {
    type: 'route',
    name: '매뉴얼보기',
    key: 'manualdetail',
    icon: <Icon fontSize='small'>dashboard</Icon>,
    route: '/manual/detail',
    component: <PrivateRoute element={<ManualDetail />} />,
  },

  {
    type: 'collapse',
    name: '공지사항',
    key: 'boards',
    icon: <Icon fontSize='small'>announcement</Icon>,
    route: '/boards',
    component: <PrivateRoute element={<Boards />} />,
  },
  {
    type: 'route',
    name: '공지보기',
    key: 'boarddetail',
    icon: <Icon fontSize='small'>person</Icon>,
    route: '/boards/detail/:id',
    component: <PrivateRoute element={<NoticeDetail />} />,
  },
  {
    type: 'collapse',
    name: '기기관리',
    key: 'machine',
    icon: <Icon fontSize='small'>dvr</Icon>,
    route: '/machine',
    component: <PrivateRoute element={<Machine />} />,
  },
  {
    type: 'collapse',
    name: 'QR 코드 생성',
    key: 'qrcode',
    icon: <Icon fontSize='small'>qr_code</Icon>,
    route: '/qrcode',
    component: <PrivateRoute element={<QRCodeGenerator />} />,
  },
  {
    type: 'collapse',
    name: '리뷰 보기',
    key: 'reviews',
    icon: <Icon fontSize='small'>rate_review</Icon>,
    route: '/reviews',
    component: <PrivateRoute element={<ReviewList />} />,
  },
  {
    type: 'collapse',
    name: '리뷰 소셜 작성',
    key: 'review-manage',
    icon: <Icon fontSize='small'>create</Icon>,
    route: '/review-manage',
    component: <PrivateRoute element={<ReviewManage />} />,
  },
  {
    type: 'collapse',
    name: '포스팅 관리',
    key: 'posting-manage',
    icon: <Icon fontSize='small'>manage_accounts</Icon>,
    route: '/posting-manage',
    component: <PrivateRoute element={<PostingManagement />} />,
  },
  {
    type: 'collapse',
    name: '고객센터',
    key: 'helpdesk',
    icon: <Icon fontSize='small'>call</Icon>,
    route: '/helpdesk',
    component: <HelpDesk />,
  },
  {
    type: 'collapse',
    name: '로그아웃',
    key: 'sign-out',
    icon: <Icon fontSize='small'>login</Icon>,
    route: '/authentication/sign-out',
    component: <SignOut />,
  },
  {
    type: 'route',
    name: '로그인',
    key: 'sign-in',
    icon: <Icon fontSize='small'>login</Icon>,
    route: '/authentication/sign-in',
    component: <SignIn />,
  },
  {
    type: 'route',
    name: '리뷰 작성',
    key: 'review-write',
    icon: <Icon fontSize='small'>edit</Icon>,
    route: '/review/:branchCode',
    component: <ReviewWrite />,
  },
  {
    type: 'route',
    name: '리뷰 성공',
    key: 'review-success',
    icon: <Icon fontSize='small'>check_circle</Icon>,
    route: '/review/success',
    component: <ReviewSuccess />,
  },
  {
    type: 'route',
    name: 'OAuth 콜백',
    key: 'oauth-callback',
    icon: <Icon fontSize='small'>security</Icon>,
    route: '/oauth-callback',
    component: <OAuthCallback />,
  },
  {
    type: 'route',
    name: '개인정보처리방침',
    key: 'privacy-policy',
    icon: <Icon fontSize='small'>shield</Icon>,
    route: '/privacy-policy',
    component: <PrivacyPolicy />,
  },
];

export default routes;
